import {
   IconFillColor,
   IconSize,
   IconWrapper,
   QuestionmarkCircleIcon,
   StyledMargin,
   Tooltip,
} from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../translations';

export const DiagnosisInformationAccordionSectionDecorator = (): JSX.Element => {
   return (
      <Tooltip
         testId={'diagnosis'}
         content={patientMedicalInformationTranslationKeys.diagnosis.tooltip}
         maxWidth={'410px'}
      >
         <StyledMargin top={-2}>
            <IconWrapper testId={'diagnosis'} fillColor={IconFillColor.PRIMARY} size={IconSize.SMALL}>
               <QuestionmarkCircleIcon />
            </IconWrapper>
         </StyledMargin>
      </Tooltip>
   );
};
